import React from 'react'
import { MainDiv } from '../Default/MainDiv'
import { MainContent } from './MainContent'


export const LiveAttendance=()=> {
  return (
    <>
    <MainDiv>
    <MainContent/>
    </MainDiv>
    </>
    
  )
}
